import React from 'react';
import styled from "styled-components";
import {ReactComponent as Icon} from '../assets/icons/iconmonstr-trash-can-lined.svg';


const IconoDelete = styled(Icon)`
height: 20px;
fill: #fff;
`


const IconDelete = () => {
    return ( 
        <>
            <IconoDelete></IconoDelete>
        </>
     );
}
 
export default IconDelete;